import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api from "../lib/axios";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"checking" | "ok" | "already" | "error">("checking");
  const [message, setMessage] = useState("Verifying…");

  useEffect(() => {
    const token = searchParams.get("token");
    console.debug("[VerifyEmail] mounted; token?", !!token);
    if (!token) {
      setStatus("error");
      setMessage("❌ Invalid or missing token.");
      return;
    }

    (async () => {
      try {
        const res = await api.get("/auth/verify-email", { params: { token } });
        const msg = String(res?.data?.message || "");
        if (msg.toLowerCase().includes("already")) {
          setStatus("already");
          setMessage("✅ Already verified. Redirecting to sign in…");
        } else {
          setStatus("ok");
          setMessage("✅ Email verified! Redirecting to sign in…");
        }
        setTimeout(() => navigate("/"), 1500);
      } catch (err: any) {
        console.error("verify-email failed:", err?.response?.data || err);
        setStatus("error");
        setMessage(
          `❌ Verification failed${err?.response?.data?.message ? `: ${err.response.data.message}` : "."}`
        );
      }
    })();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md text-center space-y-4">
        <h1 className="text-2xl font-semibold">Email verification</h1>
        <p className={status === "error" ? "text-red-600" : "text-gray-700"}>{message}</p>
        {status === "error" && (
          <div className="text-sm text-gray-500">
            <p>
              Need a new link?{" "}
              <Link to="/verify-reminder" className="underline hover:text-black">
                Resend verification email
              </Link>
            </p>
            <p className="mt-3">
              <Link to="/" className="underline hover:text-black">Back to sign in</Link>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
